export function converterData (date) {
    const newDate = new Date(date);
    return newDate.toLocaleString()
} 
